import { render, staticRenderFns } from "./RicaRegistration.vue?vue&type=template&id=e19bf3d8&"
import script from "./RicaRegistration.vue?vue&type=script&lang=js&"
export * from "./RicaRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports